import useBalances, { BALANCES_PAGE_SIZE } from "@/src/hooks/features/rewardly/use-balances";
import { ActivityIndicator, View } from "react-native";
import ScPagination from "../../ui-kit/pagination";
import SeasonToolbar from "../season-toolbar";
import BalancesTable from "./balances-table";

const AllBalances = () => {
  const {
    search, handleSearch,
    selectedSeasonId, handleSeasonChange,
    seasonOptions,
    isCurrentSeason,
    balances, isLoading,
    totalItems, totalPages, currentPage, setPage,
    handleExport,
    isExporting
  } = useBalances();

  if (isLoading) {
    return (
      <View className="flex-1 justify-center items-center py-12">
        <ActivityIndicator size="large" />
      </View>
    );
  }

  return (
    <View className="flex-1 flex-col gap-4">
      <SeasonToolbar
        search={search}
        onSearchChange={handleSearch}
        seasonOptions={seasonOptions}
        selectedSeasonId={selectedSeasonId}
        onSeasonChange={handleSeasonChange}
        isCurrentSeason={isCurrentSeason}
        onExport={handleExport}
        isExporting={isExporting}
      />
      <BalancesTable balances={balances} />
      {totalItems > 0 && (
        <ScPagination
          currentPage={currentPage}
          totalPages={totalPages}
          pageSize={BALANCES_PAGE_SIZE}
          totalItems={totalItems}
          onPageChange={setPage}
        />
      )}
    </View>
  );
};

export default AllBalances;
